 $(document).ready(function() {
  $('.collection_swatches a').hover(function() {
    const dataLabel = $(this).data('label');
    const parent = $(this).closest('.collection_swatches');
    const soldOutElement = parent.siblings('.swatch_sold_out_text').find('.variant_soldout#' + dataLabel);

    if (soldOutElement) {
      soldOutElement.removeClass('hide').addClass('show');
     }
  }, function() {
    const dataLabel = $(this).data('label');
    const parent = $(this).closest('.collection_swatches');
    const soldOutElement = parent.siblings('.swatch_sold_out_text').find('.variant_soldout#' + dataLabel)
    soldOutElement.addClass('hide').removeClass('show');
  });
});


     